export default __webpack_public_path__ + "static/media/unauthorise-repair1.8856b7aa.png";